import Slider from "react-slick";
import Zoom from 'react-reveal/Zoom';
import CONSTANTS from "../../utils/constants/CONSTANTS";

import "./index.scss";

const WorkoutAnywhereSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  return (
    <div className="workout-slider">
      <Zoom>
        <Slider {...settings}>
          {CONSTANTS.workoutSliderContent.map((value, index) => (
            <div key={index} className="workout-slide">
              <img className="image" src={value.img} alt="slide image" />
              <div className="title">{value.title}</div>
              <div className="title">{value.subTitle}</div>
            </div>
          ))}
        </Slider>
      </Zoom>
    </div>
  );
};

export default WorkoutAnywhereSlider;
